import { useEffect, useState } from "react";
import { _single } from "../../../core/services/dataBean/EntityCatalog";

interface Props {
    label?: string;
    idSelector: number;
    onChange: any;
    returnType?: "ID" | "Object";
}

export const SelectIDLnAssigned = ({ label, idSelector, onChange, returnType = "ID" }: Props) => {

    const [lista, setLista] = useState(_single.getIDLnFunctional());
    const [id, setID] = useState<number | null>(null);

    useEffect(() => {
        if (lista.length == 1) {
            const data = lista[0].DataBeanProperties;
            const selectedItem = lista.find(item => item.DataBeanProperties.IDLnFunctionalID === data.IDLnFunctionalID);
            onChange(returnType === "Object" ? selectedItem?.DataBeanProperties : data.IDLnFunctionalID);
            setID(data.IDLnFunctionalID);
        }
    }, [lista])

    useEffect(() => {
        if (idSelector !== id) {
            setID(idSelector);
        }
    }, [idSelector]);

    const setValue = (e: number | null) => {
        setID(e);
        if (onChange) {
            if (e === null) {
                onChange(null); // Devuelve null si se seleccionan los puntos suspensivos
            } else {
                const selectedItem = lista.find(item => item.DataBeanProperties.IDLnFunctionalID === e);
                onChange(returnType === "Object" ? selectedItem?.DataBeanProperties : e);
            }
        }
    };

    return (
        <>
            <label>{label ? label : 'Areas Asignadas'} </label>
            <select
                className="form-select"
                value={id !== null ? id : ""}
                onChange={(e) => {
                    const value = e.target.value ? parseInt(e.target.value) : null;
                    setValue(value);
                }}
            >
                <option value="">...</option>
                {lista.map((item: any, index: number) => {
                    return (
                        <option key={index} value={item.DataBeanProperties.IDLnFunctionalID}>
                            {item.DataBeanProperties.IDLnFunctionalID} - {item.DataBeanProperties.FunctionalIDName}
                        </option>
                    );
                })}
            </select>
        </>
    );
};
